import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthLayout from "./routes/middleware/AuthLayout";
import NonAuthLayout from "./routes/middleware/NonAuthLayout";
import { authRoutes, nonAuthRoutes } from "./routes/AllRoutes";
import AuthProvider from "./context/AuthContext";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/common/ScrollToTop";
const App = () => {
  // Renders authenticated routes
  const renderAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<AuthLayout>{route.component}</AuthLayout>}
      />
    ));
  };

  // Renders non-authenticated routes
  const renderNonAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<NonAuthLayout>{route.component}</NonAuthLayout>}
      />
    ));
  };

  return (
    <React.Fragment>
      <BrowserRouter>
        <AuthProvider>
          <div>
            <ScrollToTop />
            <Routes>
              {renderNonAuthRoutes(nonAuthRoutes)}
              {renderAuthRoutes(authRoutes)}
            </Routes>
            <Toaster></Toaster>
          </div>
        </AuthProvider>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
